<template>
  <v-expansion-panel-header
    v-show="!isHideHeader"
    v-slot="{  }"
    expand-icon=""
    style="padding: 0 0 10px 0;"
    :style="{
      'border-radius': `${borderRadius} ${borderRadius} 0 0`,
      'background-color': BGColor, 'color': Color
    }"
    @click="handleClickMainMenu"
  >
    <allergens-filter v-if="!isSimulation && allergenFilters" />
    <v-layout
      v-if="isMenu"
      wrap
      align-center
      justify-center
    >
      <v-flex xs12
        :style="{ 'margin-left': allergenFilters ? '20px' : '0'}"
      >
        <img
          :src="Logo"
          width="100%"
          heigth="auto"
          alt="logo"
        >
      </v-flex>
      <v-flex xs12>
        <div class="text-center"
          :style="{ 'margin-right': allergenFilters ? '-20px' : '0'}"
        >
        <custom-auth 
          :type="authType"
        />
        </div>
      </v-flex>
      <v-flex x8 v-if="isMnuLeft">
        <div
          style="margin-left: 40px">
          <v-icon
            style="margin-bottom: 5px"
            :style="{ 'color': Color }"
          >
            mdi-menu
          </v-icon>
        </div>
      </v-flex>
      <v-flex
        v-if="!isMnuLeft"
        xs4
      />
      <v-flex xs4
        v-if="!isMnuLeft"
      >
        <div class="text-center"
          :style="{ 'margin-right': allergenFilters ? '-20px' : '0',
             }"
        >
          <v-icon
            style="margin-bottom: 5px"
            :style="{ 'color': Color }"
          >
            mdi-menu
          </v-icon>
        </div>
      </v-flex>
      <v-flex xs4>
        <div class="text-right" v-if="isAdmin || !isCommonMenus">
          <v-btn v-if="onAdd" fab dark small color="#00000033" style="margin-right: 5px" @click.stop="onAdd">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-layout
      v-else
      wrap
      align-center
      justify-center
    >
      <v-flex xs12
          :style="{ 'margin-right': allergenFilters ? '-20px' : '0'}"
      >
        <img
          :src="Logo"
          width="100%"
          heigth="auto"
          alt="logo"
        >
      </v-flex>
      <v-flex xs12>
        <div class="text-center"
          :style="{ 'margin-right': allergenFilters ? '-20px' : '0'}"
        >
        <custom-auth 
          :type="authType"
        />
        </div>
      </v-flex>
      <v-flex xs12 v-if="!isDesignByCards">
        <div 
          v-bind:class="isMnuLeft ? '' : 'text-center'"
          :style="{ 'margin-right': !isMnuLeft && allergenFilters ? '-20px' : '0',
                    'margin-left': isMnuLeft ? '40px' : null,
                  }"
        >
          <v-tooltip v-model="showHelpMenu" top>
            <template v-slot:activator="{  }">
              <v-icon
                style="margin-bottom: 5px"
                :style="{ 'color': Color }"
              >
                mdi-menu
              </v-icon>
            </template>
            <span>Pulse <v-icon style="color: red">mdi-menu</v-icon> para mostrar las opciones</span>
          </v-tooltip>
        </div>
        <!-- <div class="text-center">
          <v-icon
            style="margin-bottom: 5px"
            :style="{ 'color': Color }"
          >
            mdi-menu
          </v-icon>
        </div> -->
      </v-flex>
    </v-layout>
  </v-expansion-panel-header>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import api from '@/services/api'
  import AllergensFilter from './customMenu/items/foodDrink/AllergensFilter'
  import CustomAuth from '@/components/customAuth/Index'
  import constants from '@/constants'
  import _ from 'lodash'
  export default {
    components: {
      AllergensFilter,
      CustomAuth,
    },
    props: {
      ID: {
        type: String,
        required: false,
        default: null
      },
      domain: {
        type: String,
        required: false,
        default: null
      },
      onAdd: {
        type: Function,
        required: false,
        default: null
      },
      onClickMainMenu: {
        type: Function,
        required: false,
        default: null
      },
      isDesignByCards: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      showHelpMenu: false,
      isMnuLeft: false,
    }),
    computed: {
      ...mapState('app',['authType', 'isAdmin', 'withLine', 'BGColor', 'Logo', 'Color', 'isMenuLeft']),
      isHideHeader () {
        return this.$route.query.hideHeader === 'true' ? true : false
      },
      allergenFilters () {
        return this.$store.state.app.allergenFilters ? true : false
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      borderRadius () {
        return this.isSimulation ? constants.borderRadius : null
      },
      isMenu () {
        return constants.menusRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isCommonMenus () {
        // para saber si son menús comunes entre empresas
        return this.$route.path.indexOf('/common-menus') >= 0 ? true : false
      },
    },
    watch: {
      'isMenuLeft' (v) {
        this.isMnuLeft = this.$store.state.app.isMenuLeft
      },
    },
    mounted () {
      this.isMnuLeft = this.$store.state.app.isMenuLeft
      if(!this.isSimulation) this.handleSetStats()
      // this.handleShowHelpMenu()
    },
    methods: {
      handleSetStats () {
        // añadimos los registros de accesos públicos
        api.setStats('stats', null)
          .then(response => {
          })
          .catch(error => {
            console.log('error', error)
          })
      },
      handleShowHelpMenu: _.debounce(function (e) {
        if (!this.isSimulation) this.showHelpMenu = true
      }, 2000),
      handleClickMainMenu () {
        if (this.onClickMainMenu) this.onClickMainMenu()
      },
    },
  }
</script>
<style scoped>
  .v-content {
    /* background-color: blue; */
  }
</style>
